// Бот опергруппы (deus_bot_opergruppy, common) — deathrattle.
// +0/0/2 случайному союзному юниту; 2 урона случайному вражескому юниту.

import { applyDamage } from '../../combat.js';
import { onUnitLeftField, dispatchUnitDied } from './hooks.js';

export const CARD_ID = 'deus_bot_opergruppy';

export function botOpergruppyDeathrattle(state, ownerIdx /*, card */) {
  const p = state.players[ownerIdx];
  const enemy = state.players[1 - ownerIdx];
  // Союзник — +2 HP.
  const allies = p.unitsOnField();
  if (allies.length > 0) {
    const ally = allies[state.rng.int(allies.length)];
    ally.current.hp += 2;
    state.log.add(`🤖 Бот опергруппы [${p.name}] — ${ally.name_ru} получает +0/0/2 (HP=${ally.hp})`);
  } else {
    state.log.add(`🤖 Бот опергруппы [${p.name}] — нет союзников для бонуса`);
  }
  // Враг — 2 урона.
  const enemies = enemy.unitsOnField();
  if (enemies.length > 0) {
    const target = enemies[state.rng.int(enemies.length)];
    const before = { hp: target.hp, armor: target.armor };
    applyDamage(target, 2, { pierce: false });
    state.log.add(`🤖 Бот опергруппы [${p.name}] → ${target.name_ru} [${enemy.name}]: 2 урона (HP ${before.hp}→${target.hp}, броня ${before.armor}→${target.armor})`);
    if (target.hp <= 0) {
      enemy.removeFromField(target);
      state.log.add(`✗ ${target.name_ru} [${enemy.name}] погибает`);
      dispatchUnitDied(state, { ownerIdx: enemy.id, card: target, killer: null, killerIdx: ownerIdx, killerWasCounter: false });
    }
  } else {
    state.log.add(`🤖 Бот опергруппы [${p.name}] — у противника нет юнитов для удара`);
  }
}
